import React, { useState } from "react";
import PropTypes from "prop-types";

// components:
import Tooltip from "core/Tooltip";
import TruncateText from "core/TruncateText";

// icons:
import Add from "core/ReusableIcons/Add";
import Checkmark from "core/ReusableIcons/Checkmark";
import Private from "core/ReusableIcons/Private";

// styles:
import colors from "core/colors";
import breakpoints from "core/breakpoints";
import { KitButton } from "./styles";

// custom hooks:
import { useViewport } from "js/hooks/useViewport";

const ChooseKit = ({ iconId, kits }) => {
    const { browserWidth } = useViewport();
    const isMobile = browserWidth < breakpoints.tablet.px;
    const privateIconText = "Only viewable by you";

    return kits.map(kit => {
        const isInKit = kit.icon_ids.includes(iconId) && kit.user_owned;
        const isPrivate = !kit.is_public;

        const [isSaved, updateIsSaved] = useState(isInKit);

        const handleSaveToExistingKit = e => {
            e.preventDefault();
            // todo: send mutation when saved when mutation/query is ready
            updateIsSaved(!isSaved);
        };

        const buttonStyleType = isSaved ? "solid" : "outline";

        const buttonJustifyContent = isPrivate ? "space-between" : "flex-start";

        const buttonIcon = isSaved ? <Checkmark /> : <Add />;

        const privateIconColor = isSaved ? colors.mist : colors.midnight;

        return (
            <KitButton
                key={kit.id}
                styleType={buttonStyleType}
                justifyContent={buttonJustifyContent}
                onClick={handleSaveToExistingKit}
                width="100%"
                iconPosition="left"
            >
                <div>
                    {buttonIcon}

                    <TruncateText charLimit={isMobile ? 32 : 58}>
                        {kit.name}
                    </TruncateText>
                </div>

                {isPrivate && (
                    <Tooltip size="small" message={privateIconText}>
                        <Private
                            fillColor={privateIconColor}
                            title={privateIconText}
                        />
                    </Tooltip>
                )}
            </KitButton>
        );
    });
};

ChooseKit.propTypes = {
    iconId: PropTypes.number.isRequired,
    kits: PropTypes.array
};

export default ChooseKit;
